import { useMemo } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import { getEmbedSourceAppBestURL } from 'automation-ui-source-apps/utils/sourceAppLinkUtils';
import { getSourceAppNameInPhraseMessage } from 'automation-ui-source-apps/utils/sourceAppMessageUtils';
import { getSourceApp } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnsupportedSourceApp = ({
  flow
}) => {
  const sourceAppLinkButton = useMemo(() => {
    if (!flow) {
      return null;
    }
    const sourceApp = getSourceApp(flow);
    if (!sourceApp) {
      return null;
    }
    const sourceAppName = getSourceAppNameInPhraseMessage(sourceApp);
    const sourceAppLink = getEmbedSourceAppBestURL(sourceApp, flow.uuid || undefined);
    if (!sourceAppLink) {
      return null;
    }
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        href: sourceAppLink,
        marginBlock: "400",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "fatalErrors.unsupportedSourceApp.link",
          options: {
            sourceAppName
          }
        })
      })
    });
  }, [flow]);
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    illustration: "workflows",
    title: I18n.text('fatalErrors.unsupportedSourceApp.title'),
    children: [/*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "fatalErrors.unsupportedSourceApp.message"
      })
    }), sourceAppLinkButton]
  });
};
export default UnsupportedSourceApp;